import { arrayOf, bool, func, object } from 'prop-types';
import React, { useState } from 'react';

import AsyncTable from '../../generic/Table/AsyncTable';
import { reactTableColumnShape, userShape } from '../../prop-types';
import api from '../../REST/api';
import withUsers from '../../users/withUsers/with-users';
import ExportAllCampaigns from '../ExportAllCampaigns';

function AsyncList({
  columns,
  allColumns,
  dump,
  searchParams,
  displayExportButton,
  users,
  allowSelection,
  ...rest
}) {
  const [tableFilters, setTableFilters] = useState({});

  return (
    <AsyncTable
      className="select-table"
      keyField="opportunityId"
      selectionName="campaigns"
      allowSelection
      allowFilterView
      minRows={2}
      columns={columns}
      allColumns={allColumns}
      queryFn={({ search }) => {
        return api.getCampaignsBasic({
          search: { ...searchParams, ...search },
        });
      }}
      onDownload={dump ? () => dump(searchParams) : undefined}
      setTableFilters={setTableFilters}
      {...rest}
    >
      {displayExportButton && (
        <ExportAllCampaigns
          tableFilters={tableFilters}
          searchParams={searchParams}
          className="ml-3"
        />
      )}
    </AsyncTable>
  );
}

AsyncList.propTypes = {
  columns: arrayOf(reactTableColumnShape).isRequired,
  allColumns: arrayOf(reactTableColumnShape).isRequired,
  searchParams: object, // eslint-disable-line react/forbid-prop-types,
  dump: func,
  displayExportButton: bool,
  users: arrayOf(userShape.isRequired).isRequired,
  allowSelection: bool,
};

AsyncList.defaultProps = {
  searchParams: undefined,
  dump: undefined,
  displayExportButton: false,
  allowSelection: false,
};

export default withUsers({})(AsyncList);
